export default "__VITE_ASSET__2c3c7474__"